<template>
  <div>
    <el-container v-show='showOrderPage'>
      <el-header v-if='$route.path !== "/chat"'>
        <h3 class="title">
          <el-row class="block">
            <span>工单管理 > {{pageName}}</span>
          </el-row>
        </h3>
      </el-header>
      <el-row class="work-bfb">
        <el-form :rules="rules" ref="ruleForm" :model="order" label-width="150px">
          <div v-if='!order.id' class="work-mt20">
            <el-form-item label="工单名称" prop="name" style="padding-right:90px;">
              <el-input placeholder="请输入工单名称" v-model="order.name"></el-input>
            </el-form-item>
          </div>
          <div v-for="(group, index) in order.template.fieldGroups" :key="index" :name="index">
            <div v-show="group.fields.length > 0" style="border: 1px solid rgb(220, 223, 230);margin:20px 0">
                <div style="text-align: left; font-size: 20px;margin:10px 0;">{{group.groupName}}</div>
            <div v-for="(field, fieldIndex) in group.fields" :key="fieldIndex" :name="fieldIndex">
              <div>
                <div style="width:100%;padding:0 30px;box-sizing:border-box;" v-if="field.fieldType != 'linkSessionsAndCustomer'">
                  <el-form-item :label="field.fieldType == 'linkSessionsAndCustomer' ? '' : field.fieldName">
                    <el-input v-model="field.value" v-if="field.fieldType === 'textfield'" style="width:98%"></el-input>
                    <el-input v-model="field.value" v-if="field.fieldType === 'textfield_dynamic'" style="width:98%"></el-input>
                    <el-input type="textarea" v-model="field.value" v-if="field.fieldType == 'textarea'" maxlength="500" rows=4 show-word-limit=true clearable=true resize='none' style="width:98%"></el-input>
                    <el-select v-model="field.value" filterable v-if="field.fieldType == 'select'" style="width:98%">
                      <div v-if = "getFieldValues(field)">
                        <el-option
                          v-for="option in field.fieldValues"
                          :key="option.id"
                          :label="option.val"
                          :value="option.id">
                        </el-option>
                      </div>
                    </el-select>
                    <el-select v-model="field.value" filterable style="width:98%"
                    v-if="field.fieldType == 'select_dynamic' && field.fieldTag !== 'workorder_assignee' && field.fieldTag !== 'workorder_director'">
                      <el-option
                        v-for="option in field.fieldValues"
                        :key="option.id"
                        :label="option.val"
                        :value="option.id">
                      </el-option>
                  </el-select>
                  <el-cascader v-if="showAssignee(field)" :disabled='!$store.state.order.orderPermission.assignOrder || order.status !== 0 ' style="width:98%"
                    expand-trigger="hover" @change="setCascaderValueForAsignee(field)"
                    :options="agents"
                    :props="agentProps"
                    v-model="field.values">
                  </el-cascader>
                  <el-cascader v-if="showCharger(field)" style="width:98%"
                    expand-trigger="hover" @change="setCascaderValueForCharger(field)"
                    :options="agents"
                    :props="agentProps"
                    v-model="field.values">
                  </el-cascader>
                </el-form-item>
              </div>
              <div style="width:100%;padding:0 30px;box-sizing:border-box;" v-else>
                <div class="iBusiness-body" v-if="$route.path !== '/chat'">
                    <div v-if="order.linkedSessions && order.linkedSessions.length > 0" style="margin-bottom:10px">
                     <el-tabs v-model="activeName" type="border-card" closable @tab-remove="delLinkedSession" @tab-click="tabChange">
                        <el-tab-pane v-for="(item, index) in order.linkedSessions" :key="index" :label="item.time" :name="index+''">
                         <div class="chat-wrapper session-detail" v-if="activeName === (index+'')">
                            <div class="chat-content">
                              <div class="chat-block" style="border-right:0px;">
                                <div class="chat-box">
                                  <div class="chat-news">
                                   <div v-for="(chatRecord, index) in chatRecords" :key="index" :class="chatRecord.direction === 'up' ? 'questioner' : 'answerer'" class="block">
                                      <p class="inform">
                                        <template v-if="chatRecord.direction === 'up'">
                                          <span class="username">客户</span>
                                          <span>{{ chatRecord.createTime }}</span>
                                        </template>
                                        <template v-else>
                                          <span>{{ chatRecord.createTime }}</span>
                                          <span class="username">客服</span>
                                        </template>
                                      </p>
                                      <div class="news-wrap">
                                        <template v-if="chatRecord.direction === 'up'">
                                          <div class="news-avator">
                                            <svg class="icon" aria-hidden="true">
                                              <use :xlink:href="'#icon'+ (item.direction === 'up' ? 'user-head' : 'kefu-head')" />
                                            </svg>
                                          </div>
                                          <div class="news">
                                            <p v-html="chatRecord.msgContent.content"/>
                                          </div>
                                        </template>
                                        <template v-else>
                                          <div class="news">
                                            <p v-html="chatRecord.msgContent.content"/>
                                          </div>
                                          <div class="news-avator">
                                            <svg class="icon" aria-hidden="true">
                                              <use :xlink:href="'#icon'+ (item.d === 'up' ? 'user-head' : 'kefu-head')" />
                                            </svg>
                                          </div>
                                        </template>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-tab-pane>
                      </el-tabs>
                    </div>
                  </div>
                  <div v-if="order.customer">
                   <el-form-item  label="客户名称">
                      <el-input v-model="order.customer.nameCn" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="联系方式">
                      <el-input v-model="order.customer.phone" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="客户咨询业务分类">
                      <el-input v-model="order.customer.property" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="客户渠道">
                      <el-input v-model="order.customer.source" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="客户等级">
                      <el-input v-model="order.customer.level" disabled></el-input>
                    </el-form-item>
                  </div>
                  <el-form-item>
                    <el-button type="primary" @click="linkSession" v-if='$route.name !== "finished" && $route.path !== "/chat"'>关联会话记录</el-button>
                    <el-button type="primary" @click="linkCustomer" v-if='$route.path !== "/chat" && !order.id'>关联客户</el-button>
                  </el-form-item>
                </div>
              </div>
            </div>
            </div>
          </div>
        </el-form>
        <el-row type="flex" justify="end">
          <el-button size="medium" @click="goBack">返回</el-button>
          <el-button size="medium" type="primary" @click="saveOrder" v-if='order.status !== 3'>保存</el-button>
          <el-button size="medium" type="primary" v-if='order.id && order.status !== 0 && order.status !== 3' @click="finishOrder">完成工单</el-button>
          <el-button size="medium" type="primary" v-if='order.id && $store.state.order.orderPermission.assignOrder && this.order.status === 0' @click="assignOrder">确认指派</el-button>
        </el-row>
      </el-row>
    </el-container>
    <CustomerList v-show='showCustomerListPage' v-on:confirmLink='hideCustomerListPage'/>
  </div>
</template>
<script>
import CustomerList from './CustomerList'
export default {
  name: 'Order',
  props: {
    pageName: {
      type: String,
      default: ''
    }
  },
  components: { CustomerList },
  data() {
    return {
      order: {
        name: '',
        customer: {},
        template: {}
      },
      agents: [],
      agentProps: {
        label: 'name',
        value: 'name',
        children: 'skillUsers'
      },
      activeName: '0',
      showOrderPage: true,
      showCustomerListPage: false,
      loading: false,
      islast: true,
      page: 0,
      limit: 50,
      chatRecords: [],
      rules: {
        name: [
          { required: true, message: '请输入工单名称', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {

  },
  watch: {
    // '$store.state.order.order': function(newFlag, oldFlag) {
    //   this.init()
    // }
  },
  mounted() {
    this.init()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    init() {
      this.order = this.$store.state.order.order
      if (this.$store.state.order.orderPermission.assignOrder) {
        this.getAgents()
      }

      if (!this.order.customer && this.order.customerId) {
        this.getCustomerInfo(this.order.customerId)
      }
      if (this.order.sessionIds && this.order.sessionIds.length > 0) {
        this.order.linkedSessions = []
        this.getlinkedSessionCreateTimes()
      }
    },
    getFieldValues(field) {
      if (!field.hasRequested) { // 已经轻轻过后台
        this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/system/custom_field/get?id=' + field.fieldId).then(res => {
          field.fieldValues = res.data.data[0].fieldValues
          field.hasRequested = true
          return true
        })
      }
      return true
    },
    handleScroll() {
      if (!this.loading && !this.islast) {
        var content = document.getElementsByClassName('el-tabs__content')
        const scrollTop = content[0].scrollTop
        const clientHeight = content[0].clientHeight
        const scrollHeight = content[0].scrollHeight
        const toBottom = scrollHeight - clientHeight - scrollTop
        if (toBottom <= 100) {
          this.loading = true
          this.page++
          this.getSessionDetail(this.order.linkedSessions[this.activeName].sessionId, this.page)
        }
      }
    },
    getlinkedSessionCreateTimes() {
      const params = {
        sessionIds: this.order.sessionIds
      }
      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/data/session_log/getTimeInfo', { params }).then(res => {
        if (res.data.code === 2000) {
          const results = res.data.data
          if (results.length > 0) {
            this.$nextTick(function() {
              results.forEach((res, index) => {
                var record = {
                  time: res.startTime,
                  sessionId: res.sessionId,
                  // agentId: res.agents[0]._id,
                  idx: index
                }
                this.order.linkedSessions.push(record)
              })
              // 取排序最前的session的第一页数据
              this.chatRecords = []
              this.getSessionDetail(this.order.linkedSessions[0].sessionId, 0)
              this.$forceUpdate()
              window.addEventListener('scroll', this.handleScroll, true)
            })
          }
        }
      })
    },
    tabChange() {
      window.removeEventListener('scroll', this.handleScroll)
      this.chatRecords = []
      this.page = 0
      this.loading = true
      this.islast = false
      this.getSessionDetail(this.order.linkedSessions[this.activeName].sessionId, this.page)
      this.$forceUpdate()
      window.addEventListener('scroll', this.handleScroll, true)
    },
    getSessionDetail(_sessionId, _page) {
      const params = {
        sessionId: _sessionId,
        limit: this.limit,
        page: _page
      }
      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/data/chat_log/getPage', { params }).then(res => {
        if (res.data.code === 2000) {
          const results = res.data.data
          if (results.length > 0) {
            results.forEach((session, index, results) => {
              if (session.type === 'image') {
                session.msgContent.content = '<a target="_blank" href="' + session.msgContent.url + '"><img style="max-width:150px" src="' + session.msgContent.url + '"/></a>'
              } else if (session.type === 'file') {
                session.msgContent.content = '<div><img style="max-width:60px" src="static/image/icon/file.png"><div style="font-weight:bold">' + session.msgContent.name + '</div></div>'
              }
            })
            this.chatRecords = this.chatRecords.concat(results)
            if (res.data.data.length < 50) {
              this.islast = true
            } else {
              this.islast = false
            }
            this.loading = false
          }
        }
      })
    },
    delLinkedSession(targetName) {
      this.order.linkedSessions.splice(parseInt(targetName) + 0, 1)
      if (targetName === this.activeName) {
        this.activeName = '0'
        this.tabChange()
      } else if (parseInt(targetName) < parseInt(this.activeName)) {
        this.activeName = (parseInt(this.activeName) - 1) + ''
      }
      this.$forceUpdate()
    },
    linkSession() {
      this.$router.push({ name: 'workbench.sidebar_chatlog', params: { isFromCreateOrder: true, notkeepAlive: true } })
    },
    linkCustomer() {
      this.showCustomerListPage = true
      this.showOrderPage = false
    },
    getCustomerInfo(customerId) {
      const that = this
      this.$http.get(window.$envUtils('VUE_APP_CRM_SERVICE') + '/customer/findDetail/' + customerId, {
      }).then(function(rep) {
        that.$set(that.order, 'customer', rep.data.data)
      }).catch(function(error) {
        console.log(error)
      })
    },
    saveOrder() {
      const that = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (that.order.customer === null || that.order.customer.id === undefined) {
            that.$message.error('请选择该工单关联的客户')
            return
          }
          that.order.customerId = that.order.customer.id

          that.orderCopy = JSON.parse(JSON.stringify(that.order))
          if (that.orderCopy.assignee) {
            that.orderCopy.status = 1
          }

          that.orderCopy.sessionIdsArray = []

          if (that.orderCopy.linkedSessions) {
            that.orderCopy.linkedSessions.forEach((session, index, arr) => {
              that.orderCopy.sessionIdsArray.push(session.sessionId)
            })
            that.orderCopy.sessionIds = that.orderCopy.sessionIdsArray
          }

          that.$http.post(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/order/save', {
            data: that.orderCopy
          }).then(function(response) {
            if (response.data.code === 2000) {
              if (that.$route.path === '/chat') {
                that.$store.commit('order/saveWidgetOrderUtils', { showTemplates: false, showOrders: true })
                that.$emit('goBack', true)
              } else {
                if (that.order.assignee) {
                  if (that.$route.name === 'processing') {
                    that.$emit('goBack', true)
                  } else {
                    that.$router.push({ name: 'processing' })
                  }
                } else {
                  if (that.$route.name === 'processed') {
                    that.$emit('goBack', true)
                  } else {
                    that.$router.push({ name: 'processed' })
                  }
                }
              }
            } else {
              that.$message.error(response.data.msg)
            }
          }).catch(function(error) {
            that.$message.error(error)
          })
        }
      })
    },
    assignOrder() {
      const that = this
      if (!that.order.assignee) {
        that.$message.error('请先选择指派人')
        return
      }

      // 由于v-if指令用了status属性,所以改变status属性的话会触发vue循环渲染导致页面卡死,所以用深拷贝避免直接修改原对象
      that.orderCopy = JSON.parse(JSON.stringify(that.order))
      that.orderCopy.status = 1
      that.$http.post(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/order/save', {
        data: that.orderCopy
      }).then(function(response) {
        if (that.$route.path === '/chat') {
          that.$emit('goBack', true)
        } else {
          that.$router.push({ name: 'processing' })
        }
      }).catch(function(error) {
        that.$message.error(error)
      })
    },
    finishOrder() {
      const that = this
      const params = {
        id: this.order.id,
        status: 3
      }
      this.$http.post(window.$envUtils('VUE_APP_WB_ORDER_SERVICE') + '/order/updateStatus', { data: null, params }).then(function(response) {
        if (that.$route.path === '/chat') {
          that.$emit('goBack', true)
        } else {
          that.$router.push({ name: 'finished' })
        }
      }).catch(function(error) {
        that.$message.error(error)
      })
    },
    setCascaderValueForAsignee(field, value) {
      field.value = field.values.join(',')
      this.order.assignee = field.values[field.values.length - 1]
    },
    setCascaderValueForCharger(field, value) {
      field.value = field.values.join(',')
    },
    showAssignee(field) {
      if (!field.hasExcuted) {
        if (field.fieldType === 'select_dynamic' && field.fieldTag === 'workorder_assignee') {
          field.hasExcuted = true
          if (field.value != null) {
            field.values = field.value.split(',')
          }
          return true
        }
        return false
      }
      return true
    },
    showCharger(field) {
      if (field.fieldType === 'select_dynamic' && field.fieldTag === 'workorder_director') {
        if (field.value != null) {
          field.values = field.value.split(',')
        }
        return true
      }
      return false
    },
    getAgents() {
      const that = this

      const params = {
        idArray: this.$store.state.order.orderPermission.assignOrderRange
      }
      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/skillgroup/getSkillGroup', { params }).then(res => {
        that.agents = res.data.data
      })
    },
    goBack() {
      this.$emit('goBack', false)
    },
    hideCustomerListPage() {
      this.showOrderPage = true
      this.showCustomerListPage = false
    }
  },

  beforeRouteLeave: function(to, from, next) {
    this.$store.commit('order/saveOrder', this.order)
    next()
  }
}
</script>

<style>
.el-main .el-main{
  color: #333;
  padding-top:20px
}
</style>
